import { useEffect } from "react";
import { useNavigate, useSearchParams } from 'react-router-dom';
import LoadingCard from "@components/card/LoadingCard.component";
import ApiService, { SingleRecordResponse } from "@services/api/api.service";

const BeginSystemSession = () => {
    const navigate = useNavigate();
    const [searchParams]  = useSearchParams();

    useEffect(() => {
        const initializeWithJwt = async () => {
            const code = searchParams.get('code');
            
            const results = await ApiService.getInstance().request('POST', `/system/login/exchange`, {code}) as SingleRecordResponse<any>;
            // set session auth state
            sessionStorage.setItem('plb_auth_state', JSON.stringify(results.record));

            navigate("/");
        };
        
        initializeWithJwt();
      }, []);

    return <LoadingCard />;
}

export default BeginSystemSession;